/*
  Product Card JavaScript - handles AJAX add to cart functionality
  Supports both the full form button and the quick-add icon button.
*/

(function() {
  'use strict';

  // Cart update utilities
  function updateCartIconBubble(itemCount) {
    const cartIcons = document.querySelectorAll('[id^="cart-icon-bubble"]');
    cartIcons.forEach(cartIcon => {
      let countBadge = cartIcon.querySelector('.menu-single-row__cart-count');
      if (itemCount > 0) {
        if (!countBadge) {
          countBadge = document.createElement('sup');
          countBadge.className = 'menu-single-row__cart-count';
          const icon = cartIcon.querySelector('[data-lucide]');
          if (icon) {
            cartIcon.insertBefore(countBadge, icon);
          } else {
            cartIcon.insertBefore(countBadge, cartIcon.firstChild);
          }
        }
        countBadge.textContent = itemCount;
      } else if (countBadge) {
        countBadge.remove();
      }
    });
  }

  function updateCartCountBadges(itemCount) {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    cartCountElements.forEach(el => {
      el.textContent = itemCount;
    });
  }

  async function refreshCartCount() {
    try {
      const cartResponse = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart data');
      }

      const cartData = await cartResponse.json();
      const itemCount = cartData?.item_count || 0;
      updateCartIconBubble(itemCount);
      updateCartCountBadges(itemCount);
      return cartData;
    } catch (error) {
      console.error('Error refreshing cart count:', error);
      return null;
    }
  }

  // Shared add-to-cart logic
  async function addToCart(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }],
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add to cart');
    }

    const responseData = await response.json();

    // Update cart icon bubble if section was returned
    if (responseData.sections && responseData.sections['cart-icon-bubble']) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        const parsed = new DOMParser().parseFromString(responseData.sections['cart-icon-bubble'], 'text/html');
        cartIconBubble.replaceChildren(...parsed.body.childNodes);
      }
    }

    // Refresh cart count
    const cartData = await refreshCartCount();

    // Publish cart update event
    if (window.publish && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-card',
        productVariantId: variantId,
        cartData: cartData || responseData
      });
    } else {
      document.dispatchEvent(new CustomEvent('cart-update', {
        detail: {
          source: 'product-card',
          productVariantId: variantId,
          cartData: cartData || responseData
        }
      }));
    }

    return responseData;
  }

  // Handle product card form submissions
  function initProductCardForms() {
    const productCardForms = document.querySelectorAll('.product-card__form:not([data-ajax-initialized])');

    productCardForms.forEach(form => {
      form.setAttribute('data-ajax-initialized', 'true');

      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        const form = e.target;
        const button = form.querySelector('.product-card__button');
        const variantIdInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');

        if (!button || !variantIdInput || button.disabled) {
          return;
        }

        const variantId = variantIdInput.value;
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        const buttonText = button.querySelector('.product-card__button-text');
        const buttonLoading = button.querySelector('.product-card__button-loading');
        const originalButtonText = buttonText ? buttonText.textContent.trim() : button.textContent.trim();

        // Disable button and show loading state
        button.disabled = true;
        button.classList.add('loading');

        if (buttonText) {
          buttonText.hidden = true;
          buttonText.style.display = 'none';
        }
        if (buttonLoading) {
          buttonLoading.hidden = false;
          buttonLoading.style.display = 'flex';
        } else {
          button.textContent = button.dataset.addingText || 'Adding to cart...';
        }

        try {
          await addToCart(variantId, quantity);

          // Show success message
          const addedText = button.dataset.addedText || 'Added to cart!';
          button.classList.remove('loading');

          if (buttonLoading) {
            buttonLoading.hidden = true;
            buttonLoading.style.display = 'none';
          }
          if (buttonText) {
            buttonText.hidden = false;
            buttonText.style.display = 'inline-block';
            buttonText.textContent = addedText;
          } else {
            button.textContent = addedText;
          }

          setTimeout(() => {
            if (buttonText) {
              buttonText.textContent = originalButtonText;
            } else {
              button.textContent = originalButtonText;
            }
            button.disabled = false;
          }, 2000);

        } catch (error) {
          console.error('Error adding to cart:', error);

          const errorText = button.dataset.errorText || 'Error adding to cart';
          button.classList.remove('loading');
          button.disabled = false;

          if (buttonLoading) {
            buttonLoading.hidden = true;
            buttonLoading.style.display = 'none';
          }
          if (buttonText) {
            buttonText.hidden = false;
            buttonText.style.display = 'inline-block';
            buttonText.textContent = errorText;
          } else {
            button.textContent = errorText;
          }

          setTimeout(() => {
            if (buttonText) {
              buttonText.textContent = originalButtonText;
            } else {
              button.textContent = originalButtonText;
            }
          }, 2000);
        }
      });
    });
  }

  function initAll() {
    initProductCardForms();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize for dynamically added product cards
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let needsInit = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if ((node.classList && node.classList.contains('product-card__form')) ||
                (node.querySelector && node.querySelector('.product-card__form'))) {
              needsInit = true;
            }
          }
        });
      });
      if (needsInit) initAll();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
